import { GET_RESERVATION_PROVIDER_SETTINGS_FAILURE, GET_RESERVATION_PROVIDER_SETTINGS_REQUEST, GET_RESERVATION_PROVIDER_SETTINGS_SUCCESS, GET_RESERVATION_PROVIDER_SETTINGS_CLEAR, GetReservationProviderSettingsActionTypes, GetReservationProviderSettingsState } from './types';

const defaultState: GetReservationProviderSettingsState = {
  isLoading: false,
  errorMessage: "",
};

export default function getReservationProviderSettings(state = defaultState, action: GetReservationProviderSettingsActionTypes): GetReservationProviderSettingsState {
  switch (action.type) {
    case GET_RESERVATION_PROVIDER_SETTINGS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_RESERVATION_PROVIDER_SETTINGS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_RESERVATION_PROVIDER_SETTINGS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    case GET_RESERVATION_PROVIDER_SETTINGS_CLEAR:
      return {
        ...state,
        isLoading: false,
        errorMessage: "",
        contents: undefined
      };
    default:
      return state;
  }
};
